/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://rvs3ikn4gbesxa4efr4koulwgq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:aa2389b7-f778-4e39-b285-f7767a0be1d1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_J7pMyuhL6",
    "aws_user_pools_web_client_id": "649fks9kkk0efima377besgl3p",
    "oauth": {
        "domain": "cerebrof0ae59c5-f0ae59c5-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://toolkitadmin.introhive.com/",
        "redirectSignOut": "https://toolkitadmin.introhive.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "cerebro-20210830145403-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2tnb2y8ahkqh5.cloudfront.net",
    "aws_user_files_s3_bucket": "cerebrof262a19db4a8471085838587b3fdcdf7134830-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_login_mechanism": [],
    "aws_cognito_login_mechanisms": []
};


export default awsmobile;
